import globalVar from "../utils/globalVar";

class Module12ContentData {
	constructor() {
		const initFunc = () => {
			initModules();
		};

		const initModules = () => {
			const modules = document.querySelectorAll(".module-12-content-data");

			modules.forEach((module) => {
				const dateItems = module.querySelectorAll(".date-item");
				const dateImages = module.querySelectorAll(".date-image");

				if (!globalVar.tablet.matches) {
					dateItems.forEach((item) => {
						item.addEventListener("mouseenter", () => {
							const index = item.dataset.index;

							// Ne cibler que les images de CE module
							dateImages.forEach((img) => img.classList.remove("active"));

							const targetImage = Array.from(dateImages).find(
								(img) => img.dataset.index === index
							);
							if (targetImage) {
								targetImage.classList.add("active");
							}
						});
					});
				}
			});
		};

		initFunc();
	}
}

export { Module12ContentData };
